import styled, { css } from 'styled-components';
import { Avatar } from '@bechtel/gds';

export const AvatarRegularStyled = styled(Avatar)`
  ${({ theme }) => css`
    border-width: 1px;
    border-color: ${theme.colors.white};
    margin-right: ${theme.spacings[400]};
    background-color: ${theme.colors.grey[200]};
  `}
`;